import { ref, reactive, computed } from 'vue'

export function useAsyncMethod (fn) {
  const inFlight = ref(0)
  const isPending = computed(() => inFlight.value > 0)

  const statuses = reactive({
    inFlight,
    isPending,
    isResolved: false,
    isRejected: false,
    isFinished: false
  })

  function resetStatuses () {
    statuses.isResolved = false
    statuses.isRejected = false
    statuses.isFinished = false
  }

  return new Proxy(fn, {
    get: (_, prop) => statuses[prop],
    apply: async (target, thisArg, args) => {
      resetStatuses()

      inFlight.value += 1

      try {
        const response = await target.call(thisArg, ...args)
        statuses.isResolved = true

        return response
      } catch (err) {
        statuses.isRejected = true
        throw err
      } finally {
        inFlight.value -= 1
        statuses.isFinished = true
      }
    }
  })
}
